import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, mapCourierError, useTranslation } from '@dukanti/shared';
import { verifyCourierOtp } from '@dukanti/shared/services';
import type { CourierVerificationResult, TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export interface VerifyCourierOtpVariables {
  readonly courierId: string;
  readonly otp: string;
}

export function useVerifyCourierOtp(
  storeId: string,
): UseMutationResult<CourierVerificationResult, unknown, VerifyCourierOtpVariables> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<CourierVerificationResult, unknown, VerifyCourierOtpVariables>({
    mutationFn: ({ courierId, otp }) => verifyCourierOtp(supabase, { storeId, courierId, otp }),
    onSuccess: (result) => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.list(storeId) });
      void queryClient.invalidateQueries({ queryKey: courierKeys.batches(storeId) });
      void queryClient.invalidateQueries({ queryKey: ['store-orders', storeId] });
      if (!result.success) {
        toast.error(t(mapCourierError(undefined, result) as TranslationKey));
        return;
      }
      toast.success(t('admin.couriers.verification.approved' as TranslationKey));
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
